/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetAssetPriceOptions, GetAssetPriceResponses } from '../types/GetAssetPrice'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get the current price of an asset
 * {@link /v1/price/asset/:asset_id}
 */
export function getAssetPrice<ThrowOnError extends boolean = true>(
  options: Options<GetAssetPriceOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetAssetPriceResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/price/asset/{asset_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAssetPriceResponses, ThrowOnError>>,
  )
}
